<div class="recent-operations-wrapper">
  <div class="recent-operations-content">
    <div class="section-title">Лог инвентаря</div>
    <div class="recent-operations-data">

      <form [formGroup]="filterForm" class="filter-form">
        <div>
          <p>Последние</p>
          <mat-button-toggle-group formControlName="limit" class="filter-buttons">
            <mat-button-toggle value="500">500</mat-button-toggle>
            <mat-button-toggle value="1000">1000</mat-button-toggle>
            <mat-button-toggle value="2000">2000</mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <div>
          <p>Фильтр</p>
          <mat-form-field appearance="fill" class="mat-type-select">
            <mat-select [formControl]="selectedFilters" multiple #matSelect panelClass="recent-operation-select-panel"
                        placeholder="Все типы игр">
              <input class="input-search" [formControl]="searchText" placeholder="Начни вводить...">
              <mat-divider></mat-divider>
              <div class="mat-select-list">
                <div>
                  <mat-option *ngFor="let type of gameType | filterText: [searchText.value, 'name']"
                              [value]="type.value">{{type.name}}</mat-option>
                </div>
              </div>
              <mat-divider></mat-divider>
              <button mat-flat-button color="primary" (click)="selectedValue(matSelect)">применить</button>
            </mat-select>
          </mat-form-field>
        </div>
      </form>

      <div>
        <mat-table [dataSource]="inventoryLogData" class="inventory-log-table" matSort>

          <!-- date Column -->
          <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef>Дата</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.createdAt | date: 'dd.MM.yy HH:mm'}} </mat-cell>
          </ng-container>

          <!-- type Column -->
          <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef>Тип операции</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.type + ': ' + element.agentKey}} </mat-cell>
          </ng-container>

          <!-- items Column -->
          <ng-container matColumnDef="items">
            <mat-header-cell *matHeaderCellDef>Предметы</mat-header-cell>
<!--            <mat-cell *matCellDef="let element">{{element.items | json}} </mat-cell>-->
            <mat-cell *matCellDef="let element">
              <app-inventory-item [items]="element.items"></app-inventory-item>
            </mat-cell>
          </ng-container>

          <!-- amount Column -->
          <ng-container matColumnDef="amount">
            <mat-header-cell *matHeaderCellDef>Стоимость</mat-header-cell>
            <mat-cell *matCellDef="let element"><span
              [ngClass]="element.amount>0 && element.type!=='bet'?'green':'red'">{{element.amount / 100 | currency: 'USD'}}</span></mat-cell>
          </ng-container>

          <!-- detail Column -->
          <ng-container matColumnDef="detail">
            <mat-header-cell *matHeaderCellDef>Детали</mat-header-cell>
            <mat-cell *matCellDef="let element"><mat-icon class="info-icon" (click)="openLogDetail(element.data)">info</mat-icon></mat-cell>
          </ng-container>
          <!--          {{element.data | json}}-->

          <mat-header-row *matHeaderRowDef="inventoryLogColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: inventoryLogColumns;"></mat-row>
        </mat-table>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        <mat-paginator [pageSizeOptions]="[20, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
